import { blogs } from "../data";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SectionHeader from "../components/SectionHeader";

export default function Blog() {
  return (
    <>
      <PageHero
        eyebrow="Beauty Blog"
        title="Salon notes for the season."
        desc="Makeup, hair care, and skin wellness stories from the Orchid team."
        image="https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=1700&auto=format&fit=crop&q=76"
      />

      <section className="section-pad membership-section">
        <div className="container">
          <Reveal>
            <SectionHeader eyebrow="Journal" title="Guidance from the salon floor." />
          </Reveal>
          <div className="blog-list">
            {blogs.map((blog, index) => (
              <Reveal delay={index * 80} key={blog.title}>
                <article className={`blog-feature ${index === 1 ? "featured" : ""}`}>
                  <img src={blog.image} alt={blog.title} />
                  <div>
                    <span>{blog.tag} / {blog.date}</span>
                    <h3>{blog.title}</h3>
                    <p>{blog.excerpt}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
